/* eslint-disable quote-props */
import { SxProps, Theme } from "@mui/material";

import { defaultTheme } from "../../styles/muiTheme";

export const style: SxProps = {
  width: "80px",
  height: "80px",
  border: "2px solid #FFFFFF",
  background: "#F4EFEB",
  padding: "0",
  borderRadius: "50%",
  overflow: "hidden",
  color: defaultTheme.palette.taupe.main,
  "& svg": {
    fontSize: 56,
  },
  "& span svg": {
    color: defaultTheme.palette.taupe.light,
  },
};

export const iconActionStyle = (theme: Theme) => ({
  position: "absolute",
  top: "3.1rem",
  right: "1.3rem",
  width: "2rem",
  height: "2rem",
  backgroundColor: theme.palette.primary.main,
  borderRadius: "50%",
  display: "grid",
  placeItems: "center",
  border: "2px solid #FFFFFF",
});

export const warningIconStyle = (theme: Theme) => ({
  position: "absolute",
  top: "-34px",
  right: "86px",
  width: "18px",
  height: "18px",
  borderRadius: "50%",
  display: "grid",
  placeItems: "center",
});
